import type { KeycloakError, KeycloakPromise } from 'keycloak-js';
import urlParse from 'url-parse';

import { backendClient } from '@neptune/shared/core-apis-backend-domain';
import { authClient } from '@neptune/shared/core-auth-domain';

export function ssoAuthInit() {
  return authClient.init({});
}

export async function ssoLogin(
  authClientInitPromise: KeycloakPromise<boolean, KeycloakError>,
  workspaceName: string,
) {
  const { idpHint } = await backendClient.getSsoConfig({ workspaceName });
  await authClientInitPromise;
  await authClient.login({
    redirectUri: getRedirectUri(),
    idpHint,
  });
}

export async function ssoBackToStandardFlow(
  authClientInitPromise: KeycloakPromise<boolean, KeycloakError>,
) {
  await authClientInitPromise;
  authClient.login({
    redirectUri: getRedirectUri(),
  });
}

function getRedirectUri(): string {
  const parseQuery = true;
  const url = urlParse(window.location.href, parseQuery);

  return url.query['redirectUri'] || window.location.origin;
}
